import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {CustomError} from '../../../../../libs/shared/helpers/src/types/customErrors';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {TagModel} from '../../../../models/api/tagModel';
import {CreateTagDropdownContainer} from './createTagDropdownContainer';
import {TagTemplate} from './tagEditorBody';

/*
 * Props.
 */

interface CreateSubtagDropdownProps extends DropdownProps {
  parentTag: TagModel;
  createTagAsync: (template: TagTemplate) => Promise<void | TagModel>;
  onBackButtonClick: Handler;
}

/*
 * Component.
 */

export const CreateSubtagDropdown: FC<CreateSubtagDropdownProps> = (props) => {
  const [isSaving, setIsSaving] = useState(false);
  const [tagError, setTagError] = useState<CustomError>();

  const onSaveTag = async (tag: TagTemplate) => {
    setIsSaving(true);
    setTagError(undefined);

    try {
      await props.createTagAsync(tag);

      if (props.onRequestClose) {
        props.onRequestClose();
      }
    } catch (error) {
      if (!(error instanceof CustomError)) {
        throw error;
      }

      // In case of conflict with an existing tag, display an error.
      setIsSaving(false);
      setTagError(error);
    }
  };

  return (
    <CreateTagDropdownContainer
      {...props}
      namespace={props.parentTag.namespace}
      initialNamespace={props.parentTag.namespace}
      title={<Trans id="subtag-create-title">Create subtag</Trans>}
      okButtonLabel={<Trans id="tag-create-ok">Create</Trans>}
      onOkClick={onSaveTag}
      isEditing
      isSaving={isSaving}
      tagError={tagError}
    />
  );
};
